
const STORAGE_KEY = "ai_batch_storage_item";

/**
 * Strage保存項目
 */
export interface StrageItem {
  /**
   * 選択中言語
   */
  language?: string;
}

/**
 * Storageからデータを取得します
 * @returns Strage保存項目
 */
export function getStorageItem(): StrageItem | null {
  const item = sessionStorage.getItem(STORAGE_KEY);
  if (item) {
    return JSON.parse(item);
  }
  return null;
}

/**
 * Storageにデータを設定します
 * @param item - Strage保存項目
 */
export function setStorageItem(item: StrageItem) {
  const localItem = getStorageItem();
  if (localItem) {
    if (typeof item.language !== undefined) {
      localItem.language = item.language;
    }
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(localItem));
  } else {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(item));
  }
}
